import { useMemo } from 'react';
import {
  getClientNotificationPreferences,
  getClientSupplierEmailToggle,
  removeClientEmailPreferences,
  updateClientEmailPreferences,
  updateClientSupplierEmailToggle,
} from '@/api/clients';
import {
  NotificationSettings,
  type NotificationSettingsApi,
} from '@/components/notification-settings';

interface ClientNotificationSettingsProps {
  clientId: string;
  clientName: string;
}

export function ClientNotificationSettings({
  clientId,
  clientName,
}: ClientNotificationSettingsProps) {
  const api: NotificationSettingsApi = useMemo(
    () => ({
      getPreferences: () => getClientNotificationPreferences(clientId),
      updateEmail: (data) => updateClientEmailPreferences(clientId, data),
      removeEmail: (emailAddress) => removeClientEmailPreferences(clientId, emailAddress),
      getSupplierToggle: () => getClientSupplierEmailToggle(clientId),
      updateSupplierToggle: (enabled) => updateClientSupplierEmailToggle(clientId, enabled),
    }),
    [clientId]
  );

  return (
    <NotificationSettings
      api={api}
      description={`Manage notification settings for ${clientName}. Configure which email addresses receive notifications and what types they receive.`}
      emptyEventTypesMessage="No notification event types are available for this client."
    />
  );
}

export default ClientNotificationSettings;
